
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands, getDateRange } from "@common/src/utils/common";
import dayjs from "dayjs";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const base = namespace("base");
const common_statement = namespace("common_statement");

@Component({})
@Table("loadListData")
export default class Statement extends Vue {
  @common_statement.Action queryReceiptReportList;
  @base.Action getDictionaryList;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    reportType: "1", // 时间范围类型, 1-按日,2-按月
    receiptTimeFrom: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    receiptTimeTo: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    timeType: "1"
  };
  contentList: any = [];

  toStatementView(row) {
    const dateFormat = row.receiptTime.replace(/-/g, "");
    this.$router.push(
      `/statement/receipt-report-analysis?searchForm=${JSON.stringify({
        ...this.searchForm,
        receiptTimeFrom: dateFormat,
        receiptTimeTo: dateFormat
      })}`
    );
  }

  selfData: any = [];
  serviceListCopy: any = [];
  partsListCopy: any = [];
  get searchList() {
    return [
      {
        label: t("v3_2_0.date-type"),
        type: "select",
        selectList: [
          {
            label: t("v3_2_0.payment-and-receipt-time"),
            value: "1"
          },
          {
            label: t("v213.Created-time"),
            value: "2"
          }
        ],
        prop: "timeType",
        clearable: false,
        required: true,
        value: this.searchForm.timeType
      },
      {
        label: t("v216_6.statistical-dimension"),
        type: "btn-radio",
        prop: "reportType",
        options: this.dateTypeOptions,
        value: this.searchForm.reportType,
        typeChangeMethod: this.handleDateTypeChange,
        required: true
      },
      ...(this.searchForm.reportType === "1"
        ? [
            {
              label: t("v210831.time-frame"),
              value: [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo],
              resetValue: this.getDefaultDate("1"),
              type: "daterange",
              prop: "date",
              required: true,
              disabledFuture: true,
              maxDay: 90,
              offset: -1
            }
          ]
        : [
            {
              label: t("v210831.time-frame"),
              value: [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo],
              resetValue: this.getDefaultDate("2"),
              type: "monthrange",
              prop: "month",
              required: true,
              disabledFuture: true,
              maxMonth: 12
            }
          ])
    ];
  }
  created() {
    this.init();
  }
  init() {
    this.handleDateTypeChange(this.searchForm.reportType);
    this.handleSearch(this.searchList);
  }
  handleExportData() {
    formDownload(`${window.API_URL}/receipt/excel/byReceiptType`, this.searchForm);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryReceiptReportList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.totalReceiptAmount = data.data.totalReceiptAmount;
      this.contentList = data.data.list;
      return data;
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "date" || item.prop === "month") {
          this.searchForm.receiptTimeFrom = item.value?.[0];
          this.searchForm.receiptTimeTo = item.value?.[1];
        } else {
          this.searchForm[item.valueAlias || item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  totalReceiptAmount = "";
  dateTypeOptions = [
    { label: t("sb_copy.query-by-day"), value: "1" },
    { label: t("sb_copy.query-by-month"), value: "2" }
  ];
  handleDateTypeChange(val) {
    [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo] = this.getDefaultDate(val);
    this.searchForm.reportType = val;
  }

  getDefaultDate(type: "1" | "2"): Array<string> {
    if (type === "1") {
      return getDateRange("first_day_to_today_of_current_month", "YYYYMMDD");
    } else if (type === "2") {
      return getDateRange("first_month_to_current_month_of_current_year", "YYYYMM");
    } else {
      return [];
    }
  }
}
